<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style>
html,
body,
#app {
  min-height: 100%;
  min-height: 100dvh;
  margin: 0;
}

html {
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

#app {
  font-family: 'Manrope', 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
